import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Cookie from 'utils/cookies';
import { getAboundToken } from 'components_v2/common/Abound/AboundUtils';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import PopupOverlay from '../PopupOverlay/PopupOverlay';
import AboundSignUpLoggedIn from '../Abound/AboundSignUpLoggedIn';
// import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';

const AboundSignUpPopupLoggedIn = ({
  getJssoCrosswalkObj,
  loginUserCallback,
  isWapView,
  logout,
  subscribeAndSignupAbound,
}) => {
  const [showAboundPopup, setShowAboundPopup] = useState(false);
  const [ga4Label, setGa4Label] = useState('popup_manager');
  const moduleName = 'abound_signup_loggedin';
  const onShowCallback = value => {
    if (
      window &&
      window.TimesApps.PopUpList &&
      window.TimesApps.PopUpList[moduleName]
    ) {
      window.TimesApps.PopUpList[moduleName].callbacks.onShowCallback(value);
    }
  };
  const handleShowPopUp = show => {
    setShowAboundPopup(show);
  };

  const handleClosePopup = (params = {}) => {
    const { fromOutsideClick = false } = params;
    setShowAboundPopup(false);

    analyticsWrapper('ga4', {
      event: 'user_click',
      type: fromOutsideClick
        ? 'outside_consent_pop_up'
        : 'close_consent_pop_up',
      label: ga4Label,
      category: 'abound',
    });
  };

  const showPopUp = force => {
    setShowAboundPopup(true);
    setGa4Label('popup_manager');
    const oneDayInMillis = 86400000;
    if (!force) {
      try {
        onShowCallback(true);
        localStorage.setItem(
          'aboundToShowAfter',
          new Date().getTime() + oneDayInMillis,
        );
      } catch (error) {
        //
      }
    }
  };

  useEffect(() => {
    try {
      window.TimesApps.PopUpV2Manager.cmd.push(() => {
        if (
          window.TimesApps.PopUpV2Manager &&
          window.TimesApps.PopUpV2Manager?.register &&
          typeof window.TimesApps.PopUpV2Manager.register === 'function'
        ) {
          window.TimesApps.PopUpV2Manager.register(moduleName, () => {
            const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
            const aboundToken = getAboundToken();
            let aboundToBeShown = false;
            if (
              window?.location?.href?.indexOf('/games') === -1 &&
              ssoid &&
              !aboundToken
            ) {
              aboundToBeShown = true;
            }
            if (!aboundToBeShown) {
              onShowCallback(false);
            } else {
              window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
                if (
                  (dataObj.userCountry === 'US' &&
                    dataObj.userRegion !== 'CA') ||
                  (dataObj.userCountry === 'US' &&
                    dataObj.userRegion === 'CA' &&
                    dataObj.consentGiven)
                ) {
                  showPopUp();
                } else {
                  onShowCallback(false);
                }
              });
            }
          });
        }
      });
    } catch (error) {
      console.log('Error in registering onetap popup');
    }
  }, []);

  useEffect(() => {
    const handleAboundWidgetClicked = () => {
      const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
      const aboundToken = getAboundToken();
      if (ssoid && !aboundToken) {
        setGa4Label('user_intent');
        setShowAboundPopup(true);
      }
    };

    try {
      if (typeof document !== 'undefined') {
        document.addEventListener(
          'abound-widget-clicked',
          handleAboundWidgetClicked,
        );
      }
    } catch (error) {
      // no-op
    }

    return () => {
      try {
        if (typeof document !== 'undefined') {
          document.removeEventListener(
            'abound-widget-clicked',
            handleAboundWidgetClicked,
          );
        }
      } catch (error) {
        // no-op
      }
    };
  }, []);

  return showAboundPopup ? (
    <PopupOverlay
      position={isWapView ? 'bottom' : 'topRight'}
      blackOverlayEnabled={isWapView}
      closeCallback={handleClosePopup}
      show={showAboundPopup}
      outSideClickClose
    >
      <AboundSignUpLoggedIn
        jssoCrosswalkObj={getJssoCrosswalkObj}
        loginUserCallback={loginUserCallback}
        handleShowPopUp={handleShowPopUp}
        logout={logout}
        subscribeAndSignupAbound={subscribeAndSignupAbound}
        label={ga4Label}
        handleClosePopup={() => {
          setShowAboundPopup(false);
        }}
      />
    </PopupOverlay>
  ) : null;
};
const mapStateToProps = state => ({
  aboundDataLoading: state?.abound?.dataLoading || false,
});

export default connect(mapStateToProps)(AboundSignUpPopupLoggedIn);
